import React from "react";
import Mcxwatchlist from "./Mcxwatchlist";
import { useState, useEffect, Ref } from "react";
import axios from "axios";
import { baseUrl } from "../constant.js";
import { liveRateUrl } from "../constant.js";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const Nsclist = (
  {
    title,
    exparydate,
    lotsize,
    categotyid,
    checked1,
    high,
    low,
    ltp,
    buy,
    sell,
    token,
  },
  index,
) => {
  const [isChecked, setIsChecked] = useState(checked1);
  const [price, setPrice] = useState(0);
  const [previousPrice, setPreviousPrice] = useState(0);
  const [colour, setcolour] = useState("");
  const getBuyColor = () => {
    const previousBuyPrice = localStorage.getItem(token + "-Buy-Price");

    if (previousBuyPrice > buy) {
      localStorage.setItem(token + "-Buy-Price", buy);
      console.log(previousBuyPrice, buy, token, "red");
      return { backgroundColor: "red" };
    } else if (previousBuyPrice < buy) {
      console.log(previousBuyPrice, buy, token, "green");
      localStorage.setItem(token + "-Buy-Price", buy);
      return { backgroundColor: "green" };
    } else if (previousBuyPrice === buy) {
      localStorage.setItem(token + "-Buy-Price", buy);
      const themelight = localStorage.getItem("background");
      if (themelight == 0) {
        console.log(previousBuyPrice, buy, token, "black");
        return { backgroundColor: "#1e293b" };
      } else if (themelight == 1) {
        console.log(previousBuyPrice, buy, token, "white");
        return { backgroundColor: "#edf9fe" };
      } else if (themelight == 2) {
        return { backgroundColor: "#1e5655" };
      }
    }
  };
  const getSellColor = () => {
    const previousSellPrice = localStorage.getItem(token + "-Sell-Price");

    if (previousSellPrice > sell) {
      localStorage.setItem(token + "-Sell-Price", sell);
      return { backgroundColor: "red" };
    } else if (previousSellPrice < sell) {
      localStorage.setItem(token + "-Sell-Price", sell);
      return { backgroundColor: "green" };
    } else {
      localStorage.setItem(token + "-Buy-Price", buy);
      const themelight = localStorage.getItem("background");
      if (themelight == 0) {
        return { backgroundColor: "#1e293b" };
      } else if (themelight == 1) {
        return { backgroundColor: "#edf9fe" };
      } else if (themelight == 2) {
        return { backgroundColor: "#1e5655" };
      }
    }
  };
  const nscwatch = async () => {
    var isChkChecked = 0;
    if (isChecked === 0) {
      var isChkChecked = 1;
    }
    setIsChecked(isChecked ? 0 : 1);
    const id = localStorage.getItem("users");
    const token = localStorage.getItem("token");
    const categoryid = categotyid;
    const formdata = new FormData();
    formdata.append("Token", token);
    formdata.append("category_id", categoryid);
    formdata.append("ischecked", isChkChecked);
    const nscwatchlist = await axios.post(
      baseUrl + "authController/addUserWatchList",
      formdata,
    );
  };

  const navigate = useNavigate();
  const onbuttonclick = async () => {
    const token1 = token;
    const tokenheader = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", tokenheader);
    formdata.append("token", token1);
    const rate = await axios.post(liveRateUrl, formdata);
    const fathdata = await rate.data.livedata[0];
    navigate("/markettrade", {
      state: {
        name: title,
        token: token1,
        exparydate: exparydate,
        catid: categotyid,
      },
    });
  };

  return (
    <>
      <div className="tab_search_body">
        <div className="futures_List">
          <div className="futures_list_text" key={index}>
            <Link
              to=""
              onClick={() => {
                {
                  onbuttonclick();
                }
              }}
            >
              <h3>{title}</h3>
              <h5>{exparydate}</h5>
              <h6 style={{ marginTop: "px" }}>Lot Size: {lotsize} </h6>
            </Link>
          </div>
          <div className="futures_lot_size">
            <h4 style={getBuyColor()}>{buy}</h4>
            <h5>High: {high}</h5>
          </div>
          <div className="futures_lot_size">
            <h4 style={getSellColor()}>{sell}</h4>
            <h5>Low: {low} </h5>
          </div>
          <div className="futures_Check">
            <input
              type="checkbox"
              value=""
              id="check1"
              className="form-check-input"
              onClick={() => {
                {
                  nscwatch();
                }
              }}
              checked={isChecked}
            />{" "}
            <h5 style={{ marginTop: "9px" }}>Ltp:{ltp}</h5>
          </div>
        </div>
      </div>
    </>
  );
};
export default Nsclist;
